import type {
    ICertificateSelectionUIData,
    IEmployeeTalkState,
    IRoleSelectionUIData,
    ISkillExtractionUIData,
    ISuperPowersData,
} from '@sharedInterfaces/IEmployeeTalkState';
import { useCallback } from 'react';

export const useEmployeeTalkSelectors = (talkState: IEmployeeTalkState | null) => {
    const getSelectedSkills = useCallback(() => {
        const skillComponent = Object.values(talkState?.components ?? {}).find(
            (c) => c.componentType === 'skillExtraction',
        );
        const skillData = skillComponent?.value as ISkillExtractionUIData | undefined;
        return skillData?.skills?.filter((s) => s.selected) ?? [];
    }, [talkState]);

    const getSelectedCertificates = useCallback(() => {
        const certificateComponent = Object.values(talkState?.components ?? {}).find(
            (c) => c.componentType === 'certificateSelection',
        );
        const certificateData = certificateComponent?.value as ICertificateSelectionUIData | undefined;
        return certificateData?.certificates?.filter((c) => c.selected) ?? [];
    }, [talkState]);

    const getSelectedRoles = useCallback(() => {
        const roleComponent = Object.values(talkState?.components ?? {}).find(
            (c) => c.componentType === 'roleSelection',
        );
        const roleData = roleComponent?.value as IRoleSelectionUIData | undefined;
        return roleData?.roles?.filter((r) => r.selected) ?? [];
    }, [talkState]);

    const getSelectedSuperPowers = useCallback(() => {
        const superPowerComponent = Object.values(talkState?.components ?? {}).find(
            (c) => c.componentType === 'superPowers',
        );
        const superPowerData = superPowerComponent?.value as ISuperPowersData | undefined;
        return superPowerData?.selectedSuperPowers ?? [];
    }, [talkState]);

    return {
        getSelectedSkills,
        getSelectedCertificates,
        getSelectedRoles,
        getSelectedSuperPowers,
    };
};
